<div class="card d-flex flex-column justify-content-start align-items-start h-100 w-100 p-4">

    <div *ngIf="!selectedDiscounts || selectedDiscounts.length === 0" class="w-100">
        <span>{{labels.emptyDiscountsError}}</span>
    </div>

    <div *ngIf="selectedDiscounts && selectedDiscounts.length > 0" class="w-100">

        <div class="w-100 mb-2">
            <span class="text-primary-color fw-bolder">{{labels.directDiscountsSelectorLabel}}</span>
        </div>

        <div *ngFor="let item of selectedDiscounts" class="w-100">

            <div class="d-flex flex-row justify-content-start align-items-start w-100">

                <p-checkbox
                    class="me-2"
                    [inputId]="item.discount.discountId.toString()"
                    [binary]="true"
                    [(ngModel)]="item.checked"
                    (onChange)="onCheckedDiscountChange($event, item)">
                </p-checkbox>

                <label [for]="item.discount.discountId.toString()">

                    <span>{{ item.discount.description }} ({{item.discount.discountCodes[0]?.percentage}}%)</span>

                    <button class="btn button-primary-color rounded-circle py-0 px-2 mx-2" *ngIf="item.discount.requirements"
                        [pTooltip]="tooltipContent"
                        tooltipPosition="right">
                        <fa-icon [icon]="['fas', 'question']" size="2xs"></fa-icon>
                    </button>

                    <ng-template #tooltipContent>
                        <span>{{item.discount.requirements}}</span>
                    </ng-template>

                </label>

            </div>

        </div>

    </div>

</div>
